import { InfoCircleOutlined } from '@ant-design/icons';
import BuilderBalanceModal from 'components/cash/BalanceView/BuilderBalanceModal';
import { formatUSDwithCents } from 'helpers/money.helper';
import { useComplexState } from 'hook/helper.hook';
import React from 'react';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import classnames from 'classnames';
import './BalanceView.scss';
import {
  isCb20Enrolled,
  isEligibleForCreditBuilder2,
} from 'helpers/sesameCash.helpers';

const DefaultBalanceView = ({
  datatestid,
  balance,
  updateDate,
  cashModuleVersion,
  frozenCard,
  sesameCashAccount,
  builderManager,
  userInfo,
  ...props
}) => {
  const isEligibleForCB2 = isEligibleForCreditBuilder2(userInfo);
  const title = isEligibleForCB2 ? 'Sesame Cash' : 'Sesame Cash Balance';
  return (
    <FlexContainer className="flex-column">
      <FlexContainer className={classnames({})}>
        <Label datatestid={`${datatestid}-title`} type="H3 mH5">
          {title}
        </Label>
        <FlexContainer className="align-items-center justify-center margL12"></FlexContainer>
      </FlexContainer>
      <div className="padB4" />

      <div className="padB32 mobileHide" />
      <div className="padB16 desktopHide" />
      <FlexContainer className="flex-row justify-between align-baseline">
        <Label
          datatestid={`${datatestid}-balance`}
          typeHeader={'h1'}
          className="H1 mH3"
        >
          {balance}
        </Label>
        <div className="d-hide"></div>
      </FlexContainer>
      {isEligibleForCB2 && (
        <FlexContainer className={'margT4'}>
          <Label type="Body-2 fontNeutral400">{'Available Cash'}</Label>
        </FlexContainer>
      )}
    </FlexContainer>
  );
};

const BuilderBalanceView = ({
  datatestid,
  balance,
  updateDate,
  cashModuleVersion,
  frozenCard,
  sesameCashAccount,
  builderManager,
  userInfo,
  ...props
}) => {
  const [state, setState] = useComplexState({
    visible: false,
    isDropDownOpen: false,
  });

  const onOpenClick = () => {
    setState({ visible: true });
  };
  const onCloseClick = () => {
    setState({ visible: false });
  };
  const toggleDropdown = () =>
    setState({ isDropDownOpen: !state?.isDropDownOpen });

  let title = `Sesame Debit Card (**${sesameCashAccount?.lastFourDigits})`;
  let balanceLabel = `Total Balance ${formatUSDwithCents(
    builderManager.totalCashBalance,
  )}`;

  const isCb2Enrolled = isCb20Enrolled(sesameCashAccount, userInfo);

  if (isCb2Enrolled) {
    title = 'Sesame Cash';
    balanceLabel = 'Available Cash';
  }
  return (
    <FlexContainer className="flex-column BalanceView">
      <FlexContainer className={classnames({})}>
        <Label datatestid={`${datatestid}-title`} type="H3 mH5">
          {title}
        </Label>
        <FlexContainer className="align-items-center justify-center margL12"></FlexContainer>
      </FlexContainer>
      <div className="padB4" />

      <div className="padB16 mobileHide" />
      <div className="padB12 desktopHide" />
      <FlexContainer className="balance_zone flex-col align-left">
        <FlexContainer className="flex-row justify-center align-start">
          <Label
            datatestid={`${datatestid}-balance`}
            className="balanceHeader H1 mH3"
          >
            {balance}
          </Label>
          {!isCb2Enrolled && (
            <Label type="text-center">
              <InfoCircleOutlined
                onClick={onOpenClick}
                style={{
                  position: 'relative',
                  top: 3,
                  left: 5,
                  fontSize: '20px',
                }}
                height={24}
              />
            </Label>
          )}
        </FlexContainer>
      </FlexContainer>
      <FlexContainer>
        <Label type="Body-2 fontNeutral400">{balanceLabel}</Label>
      </FlexContainer>
      <BuilderBalanceModal
        visible={state.visible}
        onCloseClick={onCloseClick}
        builderManager={builderManager}
        sesameCashAccount={sesameCashAccount}
        toggleDropdown={toggleDropdown}
        isDropDownOpen={state.isDropDownOpen}
      />
    </FlexContainer>
  );
};

export const BalanceView = props => {
  if (!props?.builderManager?.isEnrolledInBuilder) {
    return <DefaultBalanceView {...props} />;
  } else {
    return <BuilderBalanceView {...props} />;
  }
};
